import "lazysizes";
import "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import type {
  TurboBeforeFrameRenderEvent,
  TurboBeforeRenderEvent,
} from "@hotwired/turbo";

import PlacesController from "./controllers/places_controller";
import ClearValidationController from "./controllers/clear_validation_controller";
import DialogController from "./controllers/dialog_controller";
import FormAutosubmitController from "./controllers/form_autosubmit_controller";
import FormDisableOnSubmitController from "./controllers/form_disable_on_submit_controller";
import PaywallController from "./controllers/paywall_controller";
import PlausibleController from "./controllers/plausible_controller";
import LifecycleController from "./controllers/lifecycle_controller";
import ClipboardController from "./controllers/clipboard_controller";
import HeaderController from "./controllers/header_controller";
import AnimationController from "./controllers/animation_controller";
import LazyloaderController from "./controllers/lazyloader_controller";
import GalleryController from "./controllers/gallery_controller";
import { render, renderFrame } from "./render";
import { waitForTurboFrame } from "./lib/waitForTurboFrame";

const application = Application.start();
application.register("clear-validation", ClearValidationController);
application.register("dialog", DialogController);
application.register("form-autosubmit", FormAutosubmitController);
application.register("form-disable-on-submit", FormDisableOnSubmitController);
application.register("places", PlacesController);
application.register("paywall", PaywallController);
application.register("plausible", PlausibleController);
application.register("lifecycle", LifecycleController);
application.register("clipboard", ClipboardController);
application.register("header", HeaderController);
application.register("animation", AnimationController);
application.register("lazyloader", LazyloaderController);
application.register("gallery", GalleryController);
addEventListener("turbo:before-render", ((event: TurboBeforeRenderEvent) => {
  event.detail.render = (currentElement, newElement) =>
    render(currentElement, newElement, application);
}) as EventListener);

addEventListener("turbo:before-frame-render", ((
  event: TurboBeforeFrameRenderEvent
) => {
  event.detail.render = (currentElement, newElement) =>
    renderFrame(currentElement, newElement, application);
}) as EventListener);

const favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
const letters = ["N", "Y", "R", "A"];
let index = 0;
setInterval(() => {
  if (favicon) {
    favicon.href = `/assets/${letters[index % letters.length]}.svg`;
  }
  index++;
}, 2000);

(async function () {
  await waitForTurboFrame("dialog-container");
  const params = new URLSearchParams(window.location.search);
  const dialogURL = params.get("dialog");
  if (dialogURL) {
    params.delete("dialog");
    const newUrl = new URL(window.location.href);
    newUrl.search = params.toString();
    history.pushState({}, "", newUrl);
    const frame = document.querySelector("turbo-frame#dialog-content");
    if (frame) {
      frame.setAttribute("src", dialogURL);
    }
  }
})();

export { application };
